// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IVerificationCodeValidationRequestDto
 */
export interface IVerificationCodeValidationRequestDto {
    /**
     * 
     * @type {string}
     * @memberof IVerificationCodeValidationRequestDto
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof IVerificationCodeValidationRequestDto
     */
    value: string;
    /**
     * 
     * @type {string}
     * @memberof IVerificationCodeValidationRequestDto
     */
    type?: IVerificationCodeValidationRequestDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IVerificationCodeValidationRequestDto
     */
    email_source?: IVerificationCodeValidationRequestDtoEmailSourceEnum;
}

/**
* @export
* @enum {string}
*/
export enum IVerificationCodeValidationRequestDtoTypeEnum {
    EMAIL = 'EMAIL',
    SMS = 'SMS'
}
/**
* @export
* @enum {string}
*/
export enum IVerificationCodeValidationRequestDtoEmailSourceEnum {
    EMPLOYEE = 'EMPLOYEE',
    EMPLOYER = 'EMPLOYER'
}


/**
 * Check if a given object implements the IVerificationCodeValidationRequestDto interface.
 */
export function instanceOfIVerificationCodeValidationRequestDto(value: object): value is IVerificationCodeValidationRequestDto {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function IVerificationCodeValidationRequestDtoFromJSON(json: any): IVerificationCodeValidationRequestDto {
    return IVerificationCodeValidationRequestDtoFromJSONTyped(json, false);
}

export function IVerificationCodeValidationRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IVerificationCodeValidationRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'value': json['value'],
        'type': json['type'] == null ? undefined : json['type'],
        'email_source': json['email_source'] == null ? undefined : json['email_source'],
    };
}

export function IVerificationCodeValidationRequestDtoToJSON(json: any): IVerificationCodeValidationRequestDto {
    return IVerificationCodeValidationRequestDtoToJSONTyped(json, false);
}

export function IVerificationCodeValidationRequestDtoToJSONTyped(value?: IVerificationCodeValidationRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'value': value['value'],
        'type': value['type'],
        'email_source': value['email_source'],
    };
}

